<template>
  <div>
    <div class="custom-control custom-switch mb-3">
      <input
        :id="`vehicle-unidentified-${_uid}`"
        v-model="value.unidentified"
        type="checkbox"
        class="custom-control-input"
        :disabled="disabled"
      >
      <label
        class="custom-control-label"
        :for="`vehicle-unidentified-${_uid}`"
      >
        Veículo não identificado
      </label>
    </div>

    <div class="row">
      <div class="col-md-4 form-group">
        <label>Placa</label>
        <input
          v-model="value.plate"
          type="text"
          class="form-control text-uppercase"
          :disabled="disabled"
          placeholder="ABC1D23"
          maxlength="10"
          @blur="$emit('lookup-key', value.plate)"
        >
      </div>
      <div class="col-md-4 form-group">
        <label>Tipo</label>
        <select
          v-model="value.vehicle_type"
          class="form-control"
          :disabled="disabled"
        >
          <option value="">
            Selecione
          </option>
          <option value="carro">
            Carro
          </option>
          <option value="moto">
            Moto
          </option>
          <option value="caminhao">
            Caminhão
          </option>
          <option value="onibus">
            Ônibus
          </option>
          <option value="outro">
            Outro
          </option>
        </select>
      </div>
      <div class="col-md-4 form-group">
        <label>Cor</label>
        <input
          v-model="value.color"
          type="text"
          class="form-control"
          :disabled="disabled"
          placeholder="Ex: Prata"
        >
      </div>

      <div class="col-md-5 form-group">
        <label>Marca</label>
        <input
          v-model="value.brand"
          type="text"
          class="form-control"
          :disabled="disabled"
          placeholder="Ex: Fiat"
        >
      </div>
      <div class="col-md-5 form-group">
        <label>Modelo</label>
        <input
          v-model="value.model"
          type="text"
          class="form-control"
          :disabled="disabled"
          placeholder="Ex: Uno"
        >
      </div>
      <div class="col-md-2 form-group">
        <label>Ano</label>
        <input
          v-model="value.year"
          type="text"
          class="form-control"
          :disabled="disabled"
          placeholder="2020"
          maxlength="9"
        >
      </div>

      <div class="col-md-6 form-group">
        <label>RENAVAM</label>
        <input
          v-model="value.renavam"
          type="text"
          class="form-control"
          :disabled="disabled"
          placeholder="RENAVAM"
          maxlength="20"
        >
      </div>
      <div class="col-md-6 form-group">
        <label>Chassi</label>
        <input
          v-model="value.chassis"
          type="text"
          class="form-control text-uppercase"
          :disabled="disabled"
          placeholder="Chassi"
          maxlength="30"
        >
      </div>

      <div
        v-if="value.unidentified"
        class="col-12 form-group"
      >
        <label>Descrição aparente</label>
        <input
          v-model="value.apparent_description"
          type="text"
          class="form-control"
          :disabled="disabled"
          placeholder="Ex: hatch escuro, sem placa visível"
        >
      </div>

      <div class="col-12 form-group">
        <label>Observação</label>
        <textarea
          v-model="value.observation"
          class="form-control"
          rows="2"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedVehicleForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
